import React from 'react';

import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';

import { ValueGetterParams } from 'ag-grid-community';
import { BaseAgGrid } from 'src/components/BaseAgGrid';
import { AppContext } from 'src/contexts/appContext';
import { IVendorCodeOverride } from 'src/types/IVendor';
import { dateFilterOptions } from 'src/util/grid/filter';
import { dateComparator, dateFilterComparator } from 'src/util/grid/sort';

interface IVendorCodeOverridesGridProps {
    vendorCodeOverrides: IVendorCodeOverride[];
}

export const VendorCodeOverridesGrid = ({ vendorCodeOverrides }: IVendorCodeOverridesGridProps) => {
    const { metadata } = React.useContext(AppContext);

    const colDefs = [
        {
            headerName: 'Catalog code',
            field: 'catalogCode',
            filter: 'agTextColumnFilter'
        },
        {
            headerName: 'Royalty code',
            field: 'royaltyCode',
            filter: 'agTextColumnFilter'
        },
        {
            headerName: 'Service',
            field: 'serviceId',
            valueGetter: (params: ValueGetterParams) => {
                return metadata.serviceMapping[params.data.serviceId].serviceName;
            }
        },
        {
            headerName: 'Territory',
            field: 'territoryId',
            filter: 'agTextColumnFilter',
            valueGetter: (params: ValueGetterParams) => {
                return metadata.territoryMapping[params.data.territoryId].territoryCode;
            }
        },
        {
            headerName: 'Mapping start',
            field: 'mappingStart',
            comparator: dateComparator,
            filter: 'agDateColumnFilter',
            filterParams: {
                filterOptions: dateFilterOptions,
                defaultOption: 'greaterThanOrEqual',
                comparator: dateFilterComparator,
                includeBlanksInLessThan: true,
                includeBlanksInGreaterThan: true
            }
        },
        {
            headerName: 'Mapping end',
            field: 'mappingEnd',
            comparator: dateComparator,
            filter: 'agDateColumnFilter',
            filterParams: {
                filterOptions: dateFilterOptions,
                defaultOption: 'lessThanOrEqual',
                comparator: dateFilterComparator,
                includeBlanksInLessThan: true,
                includeBlanksInGreaterThan: true
            }
        }
    ];

    return (
        <Column>
            <Heading level={4}>Vendor code overrides</Heading>
            <BaseAgGrid columnDefs={colDefs} rowData={vendorCodeOverrides} domLayout={'autoHeight'} />
        </Column>
    );
};
